import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormCheckbox,
} from '@uncinc/uncinc-react-kitchen-sink';

/**
 * Order for someone else Section Component
 *
 * Renders form fields for collecting customer personal information including
 * first name, last name, email, and telephone number.
 *
 * @component
 */


const OrderForSomeOneElseSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <fieldset className="OrderForSomeoneElse-fieldset">
      <div className="row">
        <div className="col-12">
          <FormCheckbox
            title={t('checkout.order_someone_else.label')}
            fieldName="order_someone_else"
          />
        </div>
      </div>
    </fieldset>
  );
};

export default OrderForSomeOneElseSection;
